<template>
  <div class="m-wap-main" :style="{ background: homeBgImg }">
    <div class="info-box">
      <div class="c-wap-user">
        <div class="avatar-img">
          <img :src="avatar || './images/icon06.png'" />
        </div>
        <div class="user-info">
          <div class="user-name" :style="{ color: configStyle && configStyle.nameColor }">
            {{ contactInfo.name }}
          </div>
          <div
            class="login-time"
            v-if="
              contactInfo.lastLoginTime && contactInfo.lastLoginTime !== '--'
            "
          >
            最后登录时间:{{ contactInfo.lastLoginTime }}
          </div>
        </div>
      </div>
      <div class="user_meeting" v-if="hasMeeting" :class="configStyle && configStyle.themeColor ? 'fanake' : ''">
        <div class="user_tit" :style="{ color: configStyle&&configStyle.formColor }">
          我的会议
        </div>
        <div class="user_activity">
          <div
          v-if="hasMeeting && hasWebinar"
            class="activity_box"
            :style="{ background: configStyle&&configStyle.mettingBgColor }"
          >
            <div class="Online">
              <div class="online_tit" :style="{ color: configStyle&&configStyle.formColor }">
                <router-link to="/wap/meeting/webinar">线上活动</router-link>
                <span
                  class="icon icontemp right u-ml12"
                  :style="{ color: configStyle&&configStyle.nameColor }"
                ></span>
              </div>
              <div class="online_num" :style="{ color: configStyle&&configStyle.nameColor }">
                {{ webinarTotal ? webinarTotal : 0 }}
              </div>
            </div>
            <div
              class="online_tubiao"
              :style="{ background: configStyle&&configStyle.themeColor }"
            ></div>
            <div
              class="online_tubiaoBg"
              :style="{ background: configStyle&&configStyle.themeColor }"
            >
              <span class="icon icontemp a-bianzu2"></span>
              <!-- <image src="../images/xianshang.png" /> -->
            </div>
          </div>
          <div
            v-if="hasMeeting && hasSeminar"
            class="activity_box"
            :style="{ background: configStyle&&configStyle.mettingBgColor }"
          >
            <div class="Online">
              <div class="online_tit" :style="{ color: configStyle&&configStyle.formColor }">
                <router-link to="/wap/meeting/seminar">线下活动</router-link>
                <span
                  class="icon icontemp right u-ml12"
                  :style="{ color: configStyle&&configStyle.nameColor }"
                ></span>
              </div>
              <div class="online_num" :style="{ color: configStyle&&configStyle.nameColor }">
                {{ seminarTotal ? seminarTotal : 0 }}
              </div>
            </div>
            <div
              class="online_tubiao"
              :style="{ background: configStyle&&configStyle.themeColor }"
            ></div>
            <div
              class="online_tubiaoBg"
              :style="{ background: configStyle&&configStyle.themeColor }"
            >
              <span class="icon icontemp a-bianzu3"></span>
            </div>
          </div>
        </div>
      </div>
      <ul
        class="c-wap-personal"
        :class="configStyle&&configStyle.themeColor ? 'fanake' : ''"
      >
        <li
          :style="{
            'border-bottom': `1px solid ${
              configStyle&&configStyle.borderColor ? configStyle.borderColor : '#f2f2f2'
            }`
          }"
        >
          <div class="icons-img">
            <!-- <img src="../../assets/images/icon07.png" alt="" /> -->
            <span
              class="icon icontemp a-bianzu1"
              :style="{ color: configStyle&&configStyle.themeColor }"
            ></span>
          </div>
          <div class="opea-tip" :style="{ color: configStyle&&configStyle.borderColor }">
            <span class="icon icontemp right"></span>
          </div>
          <div class="opea-tit" :style="{ color: configStyle&&configStyle.formColor }">
            <router-link to="/wap/basis">基本信息</router-link>
          </div>
        </li>
        <li
          :style="{
            'border-bottom': `1px solid ${
              configStyle&&configStyle.borderColor ? configStyle.borderColor : '#f2f2f2'
            }`
          }"
        >
          <div class="icons-img">
            <span
              class="icon icontemp wendang"
              :style="{ color: configStyle&&configStyle.themeColor }"
            ></span>
          </div>
          <div class="opea-tip" :style="{ color: configStyle&&configStyle.borderColor }">
            <span class="icon icontemp right"></span>
          </div>
          <div class="opea-tit" :style="{ color: configStyle&&configStyle.formColor }">
            <router-link to="/wap/account">账号信息</router-link>
          </div>
        </li>
        <li
          :style="{
            'border-bottom': `1px solid ${
              configStyle&&configStyle.borderColor ? configStyle.borderColor : '#f2f2f2'
            }`
          }"
        >
          <div class="icons-img">
            <span
              class="icon icontemp suoding"
              :style="{ color: configStyle&&configStyle.themeColor }"
            ></span>
          </div>
          <div class="opea-tip" :style="{ color: configStyle&&configStyle.borderColor }">
            <span class="icon icontemp right"></span>
          </div>
          <div class="opea-tit" :style="{ color: configStyle&&configStyle.formColor }">
            <router-link to="/wap/password">修改密码</router-link>
          </div>
        </li>
        <li
          v-if="hasFile"
          :style="{
            'border-bottom': `1px solid ${
              configStyle&&configStyle.borderColor ? configStyle.borderColor : '#f2f2f2'
            }`
          }"
        >
          <div class="icons-img">
            <span
              class="icon icontemp bianzu"
              :style="{ color: configStyle&&configStyle.themeColor }"
            ></span>
          </div>
          <div class="opea-tip" :style="{ color: configStyle&&configStyle.borderColor }">
            <span class="icon icontemp right"></span>
          </div>
          <div class="opea-tit" :style="{ color: configStyle&&configStyle.formColor }">
            <router-link to="/wap/file">我的资料下载</router-link>
          </div>
        </li>
      </ul>
    </div>
    <!-- <div class="c-wap-link" v-for="o in list" :key="o.id">
      <div class="icons-img">
        <img :src="o.icon_url" />
      </div>
      <div class="opea-tit" v-if="o.children">
        <a>{{ o.name }}</a>
        <ul class="child-link">
          <li v-for="d in o.children" :key="d.id">
            <router-link :to="d.jump_url">{{ d.name }}</router-link>
            <span class="icon icontemp right"></span>
          </li>
        </ul>
      </div>
      <div class="opea-tip" v-if="!o.children">
        <span class="icon icontemp right"></span>
      </div>
      <div class="opea-tit" v-if="!o.children">
        <router-link :to="o.jump_url" v-if="o.is_system == 1">{{
          o.name
        }}</router-link>
        <a :href="o.jump_url" target="_blank" v-if="o.is_system != 1">{{
          o.name
        }}</a>
      </div>
    </div> -->
    <div class="c-form t-center r-wap-save">
      <button class="form-btn save logout"
      :style="{ color: configStyle&&configStyle.formColor ? configStyle.formColor : '#1665d8',
      border: `1px solid ${
              configStyle&&configStyle.borderColor ? configStyle.borderColor : '#1665d8'
            }`
      }"
      @click="logout()">退出登录</button>
    </div>
  </div>
</template>

<script>
import { interact } from "fire-wind-water/tools/interact";
// import { $subscriber } from "fire-wind-water/tools/subscriber";
import member from "../../services/member";
import {
  memberFormId,
  schemaId,
  sess,
  tenantId,
  domain
} from "../../common/sbase";
import { ck } from "fire-wind-water/cookie";
import { cr } from "fire-wind-water/core";
import { $subscriber } from "fire-wind-water/tools/subscriber";

export default {
  name: "Home",
  data() {
    return {
      menuSetting: {
        metting: {
          img: "./images/icon10.png",
          isChild: 1
        },
        seminar: {
          jump_url: "/wap/meeting/seminar",
          routeName: ["Meeting"]
        },
        webinar: {
          jump_url: "/wap/meeting/webinar",
          routeName: ["Meeting"]
        },
        file: {
          img: "./images/icon11.png",
          jump_url: "/wap/file",
          routeName: ["File"]
        }
      },
      list: [],
      routeName: "",
      loginUrl: "",
      contactInfo: {},
      avatar: "",
      seminarTotal: "",
      webinarTotal: "",
      configStyle: null,
      imgUrl: "",
      hasMeeting: false,
      hasSeminar: false,
      hasWebinar: false,
      hasFile: false,
      homeBgImg: "url(./images/bgImg.png) no-repeat center/100% 100%",
    };
  },
  created() {
    document.title = "个人中心";
    this.isLink();
    $subscriber.subscribe("config-style", data=>{
      this.configStyle = data;
      this.imgUrl = this.configStyle.homeBgImg;
      this.homeBgImg =
        "url(" +
        this.imgUrl +
        ") no-repeat center/100% 100%";
      setTimeout(()=>{
        window.$sk.loading.hide();
      },200)

    });
    $subscriber.subscribe("s-contact-init", data => {
      this.contactInfo = data;
      this.avatar = data.headImgUrl;
    });
    this.getMenu();
    $subscriber.subscribe("s-member-init", data => {
      this.loginUrl = `${data.originUrl.wap}&backUrl=${encodeURIComponent(
        window.location.href
      )}`;
    });
    this.getWebinarList();
    this.getSeminarList();
  },
  watch: {
    $route: {
      handler: function() {
        this.isLink();
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    isLink() {
      if (interact.isMobile != 1) {
        window.location.hash = "#/pc";
      }
    },
    getMenu() {
      member.menuQuery({ tenantId, sess }).subscribe(data => {
        if (data.result == "0") {
          this.initList(data.content.items);
        } else {
          this.$message.error(data.desc);
        }
      });
    },
    initList(data) {

      this.list = [];
      let mc = [];
      cr.each(data, d => {
        if (d.field_name === "contact") {
          return;
        }
        if (/(webinar)|(seminar)/.test(d.field_name)) {
          d.jump_url = this.menuSetting[d.field_name].jump_url;
          mc.push(d);
        } else {
          if (this.menuSetting[d.field_name]) {
            d.jump_url = this.menuSetting[d.field_name].jump_url || d.jump_url;
            d.icon_url = d.icon_url || this.menuSetting[d.field_name].img;
          }
          this.list.push(d);
        }
      });
      cr.each(this.list, d => {
        if (d.field_name === "metting") {
          d.children = mc;
          this.hasMeeting = true;
          d.children?.forEach(i => {
            if (i.name === "线上活动") {
              this.hasWebinar = true;
            }
            if (i.name === "线下活动") {
              this.hasSeminar = true;
            }
          })
        }
        if (d.field_name === "file") {
          this.hasFile = true;
        }
      });
      if (!this.hasSeminar && !this.hasWebinar){
        this.hasMeeting = false;
      }
    },
    logout() {
      window.console.log("domain =>" + domain);
      ck.removeCookie(`smarketMember_${schemaId}`, {
        path: "/",
        domain: domain
      });
      member
        .logout({
          memberFormId: memberFormId,
          schemaId: schemaId,
          globalUserId: decodeURIComponent(ck.cookie("globalUserId")).replaceAll('"', ''),
          sess: sess,
          url: window.location.href
        })
        .subscribe(data => {
          if (data.result == 0) {
            window.$sk.goto(this.loginUrl);
          }
        });
    },
    getWebinarList() {
      const info = {
        tenantId: tenantId,
        videoType: -1,
        sess: sess,
        webStatus: -1,
        orderBy: "startTime",
        sort: "desc",
        start: 0,
        num: 10
      };
      member.webinarList(info).subscribe(data => {
        if (data.result == 0) {
          this.webinarTotal = data.content.total;
        } else {
          this.$message.error(data.desc);
        }
      });
    },
    getSeminarList() {
      const info = {
        tenantId: tenantId,
        sess: sess,
        status: -1,
        needTopic: 1,
        sortName: "startTime",
        sortOrder: "desc",
        start: 0,
        num: 10
      };
      member.seminarList(info).subscribe(data => {
        if (data.result == 0) {
          this.seminarTotal = data.content.total || 0;
        } else {
          this.$message.error(data.desc);
        }
      });
    }
  }
};
</script>

<style scoped></style>
